<template>

	<div style="background-color: rgb(51, 51, 51);height: 100vh;">
		<!--左侧导航头部logo-->
		<!-- <div class="home-icon">
			<img src="../assets/images/logo.png" alt="" style="width: 100%;height: 60px; margin-top: 30px;">
		</div> -->
		<div class="home-icon">
					<img src="../assets/images/navLogo.png" alt="" style="width: 100%;">
				</div>
		<!-- <p class="Home-text">首页</p> -->
		<el-menu background-color="#333" text-color="#fff" unique-opened active-text-color="#33CC33" router>
			<!--一级菜单-->
			<el-menu-item :index="item.id + ''" v-for="item in mockList" :key="item.id">
				<!-- <i class="el-icon-setting"></i> -->
				<!--一级菜单的模板区域-->
				<template slot="title">
					<span class="submenu-span" style="font-size:18px">{{item.name}}</span>
				</template>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'navmenu',
		data() {
			return {
				mockList: [{
						'id': '/accountManagement',
						'name': '账号管理',
					},
					{
						'id': '/TeakManagement',
						'name': '产品管理',

					},
					{
						'id': '/seezhengshu',
						'name': '授权证书查看',
					},
					// {
					// 	'id': '/testManagement',
					// 	'name': '试题管理',
					// },
          {
            'id': '/systemConfig',
            'name': '系统配置',
          }
				]
			};
		},
	}
</script>

<style scoped>
	.el-container {
		width: 19.06%;
		height: 100vh;
	}

	.el-aside {
		background-color: #333;
	}

	.el-menu {
		border-right: none;
		font-size: 20px;
	}

	.home-icon {
		width: 50%;
		margin: 0 0 0 40px;
		/* margin: 0 auto; */
		/* height: 114px; */
		/* background: #fff; */
		margin-bottom: 10px;
		padding-top:10px ;
	}
	.home-icon img{
		object-fit: cover;
	}

	.Home-text {
		margin-bottom: 34px;
		margin-left: 40px;
		font-size: 18px;
		color: #fff;
	}

	.submenu-span {
		margin-left: 20px;
	}

	.el-menu-item {
		list-style-type: circle;
	}

	.item-span::before {
		content: "";
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 50%;
		background: #33CC33;
		vertical-align: middle;
		margin-right: 8px;
	}


	>>>.is-active {
		outline: 0;
		background-color: #ffffff !important;
	}
</style>
